export default __webpack_public_path__ + "static/media/premium.f3fc9b32.svg";